var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1325 13.005C29.7217 12.3533 29.2825 11.7442 28.8292 11.1775C28.305 10.5117 27.3134 10.455 26.7184 11.05L22.4684 15.3C22.78 16.235 22.8367 17.3117 22.5534 18.4308C22.0575 20.4283 20.4425 22.0433 18.445 22.5392C17.3259 22.8225 16.2492 22.7658 15.3142 22.4542C15.3142 22.4542 13.2884 24.48 11.8292 25.9392C11.1209 26.6475 11.3475 27.8942 12.2967 28.2625C13.8125 28.8433 15.385 29.1408 17 29.1408C19.5217 29.1408 21.9725 28.4042 24.2109 27.03C26.4917 25.6133 28.5459 23.5308 30.2034 20.8817C31.5492 18.7425 31.4784 15.1442 30.1325 13.005Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8617 14.1382L14.1384 19.8616C13.4159 19.1249 12.9484 18.1049 12.9484 16.9999C12.9484 14.7757 14.7617 12.9482 17 12.9482C18.105 12.9482 19.125 13.4157 19.8617 14.1382Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8541 8.1458L21.0516 12.9483C20.0175 11.9 18.5866 11.2766 17 11.2766C13.8266 11.2766 11.2766 13.8408 11.2766 17C11.2766 18.5866 11.9141 20.0175 12.9483 21.0516L8.15998 25.8541H8.14581C6.57331 24.5791 5.12831 22.95 3.89581 21.0233C2.47915 18.7991 2.47915 15.1866 3.89581 12.9625C5.53915 10.3841 7.55081 8.3583 9.78915 6.96996C12.0275 5.60996 14.4783 4.85913 17 4.85913C20.1591 4.85913 23.2191 6.0208 25.8541 8.1458Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0517 17.0001C21.0517 19.2243 19.2384 21.0518 17 21.0518C16.915 21.0518 16.8442 21.0518 16.7592 21.0234L21.0234 16.7593C21.0517 16.8443 21.0517 16.9151 21.0517 17.0001Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8409 3.15908C30.4159 2.73408 29.7217 2.73408 29.2967 3.15908L3.1592 29.3108C2.7342 29.7358 2.7342 30.4299 3.1592 30.8549C3.3717 31.0533 3.64087 31.1666 3.9242 31.1666C4.20754 31.1666 4.4767 31.0533 4.6892 30.8408L30.8409 4.68908C31.28 4.26408 31.28 3.58408 30.8409 3.15908Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.e2441d5e0ca3a24b9cff65811d3ed4c8.svg";
export { ForwardRef as ReactComponent };